module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnplayart_m2.6e6524ca47fc40c7e22089d09b7d05ff.png";